(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workflow-fragrance-reviews"] && !Shopify.designMode) return;
  try {
    
function openWorkflowReviewsFromLink(){
  const params=new URLSearchParams(location.search);
  if(location.hash.includes('judgeme') || params.has('judgeme_review_uuid')){
    const panel=document.getElementById('workflow-customer-reviews');
    if(panel) panel.open=true;
  }
}
openWorkflowReviewsFromLink();
window.addEventListener('hashchange',openWorkflowReviewsFromLink);

  } catch(e) { console.error(e); }
})();
})();
